module.exports = __webpack_public_path__ + "p2_img1.jpg?f1ff9fccb99a866ce4aec700b0b88f14";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p2/p2_img1.jpg
// module id = 108
// module chunks = 0